export default __webpack_public_path__ + "static/media/035-id-card.b7df6827.svg";